import { SLOTS, SLOT_COUNT, emptyDay, dateKey } from '../data/slots.js';
import { CATEGORIES, CAT_BY_ID, CAT_TREE } from '../data/categories.js';
import { INSIGHTS } from '../data/insights.js';

// 行经数据存在 day.cycle 对象里（live CycleEditor）。导出/导入用同一套中↔值映射，保证 round-trip 还原。
const CYCLE_PHASE_LABEL = { menses: '行经', ovulation: '排卵期' };
const CYCLE_FLOW_LABEL = { 1: '少', 2: '一般', 3: '多', 4: '很多' };
const CYCLE_PAIN_LABEL = ['无', '轻', '中', '重', '严重', '剧烈'];
const PHASE_BY_LABEL = { '行经': 'menses', '排卵期': 'ovulation' };
const FLOW_BY_LABEL = { '少': 1, '一般': 2, '多': 3, '很多': 4 };
const PAIN_BY_LABEL = { '无': 0, '轻': 1, '中': 2, '重': 3, '严重': 4, '剧烈': 5 };
function mealLabel(v) { return v === 'ontime' ? '按时' : v === 'late' ? '拖延' : ''; } // 导出中文；导入侧同时认中英文

function tracksToRuns(day) {
  const out = [];
  if (!day.tracks) return out;
  // Force Excel to treat time as text by wrapping with ="..." (CSV formula trick).
  const safeTime = (label) => `="${label}"`;
  for (let t = 0; t < 3; t++) {
    const arr = day.tracks[t] || [];
    let runStart = null, runCat = null, runNote = null;
    function emit(endIdx) {
      if (runCat == null || runStart == null) return;
      const s = SLOTS[runStart];
      const e = SLOTS[endIdx];
      const endH = e.h, endM = e.m + (e.span === 0.5 ? 30 : 60);
      const eh = endM >= 60 ? endH + 1 : endH;
      const em = endM >= 60 ? endM - 60 : endM;
      const startLabel = `${String(s.h).padStart(2, '0')}:${String(s.m).padStart(2, '0')}`;
      const endLabel = `${String(eh).padStart(2, '0')}:${String(em).padStart(2, '0')}`;
      out.push({ track: t, startIdx: runStart, endIdx, startLabel: safeTime(startLabel), endLabel: safeTime(endLabel), catId: runCat, note: runNote || '' });
    }
    for (let i = 0; i < arr.length; i++) {
      const cat = arr[i];
      const note = (day.notes || {})[`${t}:${i}`];
      if (cat !== runCat) {
        emit(i - 1);
        runStart = i; runCat = cat; runNote = note || null;
      } else if (cat != null && note && !runNote) {
        runNote = note;
      }
    }
    emit(arr.length - 1);
  }
  return out;
}

function trackName(t) { return ['娱乐·吃', '睡眠', '运动'][t] || ''; }

export function exportCsv(data) {
  const rows = [];
  rows.push(['# 第一部分：每日元数据']);
  rows.push(['日期', '三餐-早', '三餐-午', '三餐-晚', '睡眠档', '夜间h', '零星h', '半夜醒', '睡前刷手机', '睡前听书', '骨量kg', '体重kg', '效率', '情绪', '运动类型', '主要事件']);
  const dates = Object.keys(data).sort();
  dates.forEach(k => {
    const d = data[k];
    rows.push([
      k,
      mealLabel(d.meals?.breakfast),
      mealLabel(d.meals?.lunch),
      mealLabel(d.meals?.dinner),
      d.sleepDuration || '',
      d.sleepHours ?? '',
      d.napHours ?? '',
      d.nightWake ?? 0,
      d.phoneBeforeSleep ? '是' : '',
      d.listenBeforeSleep ? '是' : '',
      d.boneMass ?? '',
      d.weight ?? '',
      d.efficiency || '',
      (d.emotions || []).join('/'),
      (d.exerciseTypes || []).join('/'),
      d.mainEvent || '',
    ]);
  });
  rows.push([]);
  rows.push(['# 第二部分：时间块（合并相邻同分类）']);
  rows.push(['日期', '轨道', '开始', '结束', '分类', '备注']);
  dates.forEach(k => {
    const d = data[k];
    tracksToRuns(d).forEach(run => {
      if (!run.catId) return;
      const c = CAT_BY_ID[run.catId];
      rows.push([k, trackName(run.track), run.startLabel, run.endLabel, (c && (c.label || c.name)) || run.catId, run.note]);
    });
  });
  rows.push([]);
  rows.push(['# 第三部分：行经记录']);
  rows.push(['日期', '阶段', '血量', '疼痛', '症状']);
  dates.forEach(k => {
    const cy = data[k] && data[k].cycle;
    if (!cy || !cy.phase || cy.phase === 'none') return;
    rows.push([
      k,
      CYCLE_PHASE_LABEL[cy.phase] || cy.phase,
      cy.phase === 'menses' ? (CYCLE_FLOW_LABEL[cy.flow] || '') : '',
      (typeof cy.pain === 'number') ? (CYCLE_PAIN_LABEL[cy.pain] || '') : '',
      (cy.symptoms || []).join('/'),
    ]);
  });
  // 时光画册心法：日期 + 标题（来自 insights.js 静态列表，导出供参考；导入时忽略——心法是代码内置，换设备本就在）
  rows.push([]);
  rows.push(['# 第四部分：时光画册心法']);
  rows.push(['日期', '心法标题']);
  (INSIGHTS || []).forEach(it => rows.push([it.date, it.title]));
  const csv = rows.map(r => r.map(c => {
    const s = String(c ?? '');
    return s.includes(',') || s.includes('"') || s.includes('\n') ? '"' + s.replace(/"/g, '""') + '"' : s;
  }).join(',')).join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `时间块_${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
}

function parseCsvText(text) {
  if (text.charCodeAt(0) === 0xFEFF) text = text.slice(1);
  const rows = [];
  let cur = [], cell = '', inQuote = false;
  for (let i = 0; i < text.length; i++) {
    const ch = text[i];
    if (inQuote) {
      if (ch === '"') {
        if (text[i + 1] === '"') { cell += '"'; i++; }
        else inQuote = false;
      } else cell += ch;
    } else {
      if (ch === '"') inQuote = true;
      else if (ch === ',') { cur.push(cell); cell = ''; }
      else if (ch === '\n' || ch === '\r') {
        if (ch === '\r' && text[i + 1] === '\n') i++;
        cur.push(cell); rows.push(cur); cur = []; cell = '';
      } else cell += ch;
    }
  }
  if (cell.length || cur.length) { cur.push(cell); rows.push(cur); }
  return rows;
}

function parseTimeLabel(s) {
  let str = String(s || '').trim();
  const m1 = str.match(/^="(.+)"$/);
  if (m1) str = m1[1];
  const m = str.match(/^(\d{1,2}):(\d{2})(?::\d{2})?$/);
  if (!m) return null;
  return { h: +m[1], m: +m[2] };
}

function findSlotIdx(h, m) {
  return SLOTS.findIndex(s => s.h === h && s.m === m);
}

// 老 csv 兼容别名：旧版导出的 label 字符串映射到新 id
// 不全的话遇到旧文件导入会变"未分类"
const LEGACY_CAT_ALIAS = {
  '娱乐': 'fun',
  '吃': 'eat',
  '运动': 'exercise',
  '小能熊': 'prep_xnx',
  '怦然': 'prep_pr',
};

function nameToCatId(name) {
  if (!name) return null;
  if (CAT_BY_ID[name]) return name;
  for (const c of CATEGORIES) {
    if (c.label === name || c.name === name) return c.id;
  }
  const grp = (CAT_TREE || []).find(n => n.label === name || n.id === name);
  if (grp) return grp.id;
  // Legacy alias fallback
  if (LEGACY_CAT_ALIAS[name]) return LEGACY_CAT_ALIAS[name];
  return null;
}

export async function importCsv(existingData, setData) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.csv,text/csv';
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;
    try {
      const text = await file.text();
      const rows = parseCsvText(text);
      const result = importCsvRows(rows, existingData);
      const importedDays = Object.keys(result.next).filter(k => !existingData[k] || result.touched.has(k));
      setData(result.next);
      alert(`已导入 ${importedDays.length} 天的数据`);
    } catch (e) {
      console.error(e);
      alert('导入失败：' + e.message);
    }
  };
  input.click();
}

// 经期历史导入：模版两列「经期开始日期, 经期天数(可选默认5)」。一行=一次月经，把开始日起 N 天标为「行经」。
function parseFlexDate(s) {
  const m = String(s || '').trim().match(/(\d{4})\D(\d{1,2})\D(\d{1,2})/);
  return m ? new Date(+m[1], +m[2] - 1, +m[3]) : null;
}
export async function importCycleHistory(existingData, setData) {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.csv,text/csv';
  input.onchange = async () => {
    const file = input.files[0];
    if (!file) return;
    try {
      const rows = parseCsvText(await file.text());
      const next = { ...existingData };
      let periods = 0, daysMarked = 0;
      for (const row of rows) {
        const start = parseFlexDate(row[0]); // 表头/空行无日期 → 自动跳过
        if (!start) continue;
        let len = parseInt(String(row[1] || '').trim(), 10);
        if (!Number.isFinite(len) || len < 1) len = 5;
        if (len > 14) len = 14; // 防呆
        periods++;
        for (let i = 0; i < len; i++) {
          const d = new Date(start); d.setDate(start.getDate() + i);
          const key = dateKey(d);
          const base = next[key] || emptyDay(key);
          next[key] = { ...base, cycle: { ...(base.cycle || {}), phase: 'menses' } }; // 合并，不动已有 flow/pain
          daysMarked++;
        }
      }
      if (periods === 0) { alert('没读到任何有效的经期开始日期，请检查模版（第一列填 YYYY-MM-DD）'); return; }
      setData(next);
      alert(`已导入 ${periods} 次月经，标记 ${daysMarked} 天为「行经」`);
    } catch (e) {
      console.error(e);
      alert('导入失败：' + e.message);
    }
  };
  input.click();
}

function importCsvRows(rows, existingData) {
  const next = { ...existingData };
  const touched = new Set();
  let section = null;
  let headers = null;
  for (const row of rows) {
    if (row.length === 0 || (row.length === 1 && !row[0])) { section = null; headers = null; continue; }
    const first = String(row[0] || '').trim();
    if (first.startsWith('#')) {
      section = first.includes('元数据') ? 'meta' : first.includes('时间块') ? 'blocks' : first.includes('行经') ? 'cycle' : null;
      headers = null;
      continue;
    }
    if (!headers) { headers = row.map(s => String(s || '').trim()); continue; }
    if (section === 'meta') {
      const dk = row[0] && String(row[0]).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dk)) continue;
      const base = next[dk] || emptyDay(dk);
      const get = (h) => { const i = headers.indexOf(h); return i >= 0 ? row[i] : ''; };
      const meals = { ...(base.meals || {}) };
      const m = { breakfast: get('三餐-早'), lunch: get('三餐-午'), dinner: get('三餐-晚') };
      Object.entries(m).forEach(([k, v]) => {
        v = String(v || '').trim();
        if (v === '按时' || v === 'ontime') meals[k] = 'ontime';
        else if (v === '拖延' || v === 'late') meals[k] = 'late';
      });
      const nightWake = parseFloat(get('半夜醒'));
      const sleepHours = parseFloat(get('夜间h'));
      const napHours = parseFloat(get('零星h'));
      const boneMass = parseFloat(get('骨量kg'));
      const weight = parseFloat(get('体重kg'));
      const emotions = String(get('情绪') || '').split(/[\/,，]/).map(s => s.trim()).filter(Boolean);
      const exerciseTypes = String(get('运动类型') || '').split(/[\/,，]/).map(s => s.trim()).filter(Boolean);
      next[dk] = {
        ...base,
        meals,
        sleepDuration: String(get('睡眠档') || '').trim() || base.sleepDuration,
        sleepHours: isNaN(sleepHours) ? base.sleepHours : sleepHours,
        napHours: isNaN(napHours) ? base.napHours : napHours,
        nightWake: isNaN(nightWake) ? base.nightWake : nightWake,
        phoneBeforeSleep: String(get('睡前刷手机')).trim() === '是',
        listenBeforeSleep: String(get('睡前听书')).trim() === '是',
        boneMass: isNaN(boneMass) ? base.boneMass : boneMass,
        weight: isNaN(weight) ? base.weight : weight,
        efficiency: String(get('效率') || '').trim() || base.efficiency,
        emotions: emotions.length ? emotions : (base.emotions || []),
        exerciseTypes: exerciseTypes.length ? exerciseTypes : (base.exerciseTypes || []),
        mainEvent: String(get('主要事件') || '').trim() || base.mainEvent,
      };
      touched.add(dk);
    } else if (section === 'blocks') {
      const dk = row[0] && String(row[0]).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dk)) continue;
      const trName = String(row[1] || '').trim();
      // 轨道 0 导出名是「娱乐·吃」；兼容旧/写反的「吃·娱乐」，否则该轨时间块导入时被整条丢弃
      let trackIdx = ['娱乐·吃', '睡眠', '运动'].indexOf(trName);
      if (trackIdx < 0 && trName === '吃·娱乐') trackIdx = 0;
      if (trackIdx < 0) continue;
      const startT = parseTimeLabel(row[2]);
      const endT = parseTimeLabel(row[3]);
      const catName = String(row[4] || '').trim();
      const note = String(row[5] || '').trim();
      const catId = nameToCatId(catName);
      if (!catId || !startT || !endT) continue;
      const base = next[dk] || emptyDay(dk);
      const newTracks = (base.tracks || [[], [], []]).map(t => [...t]);
      let sIdx = findSlotIdx(startT.h, startT.m);
      if (sIdx < 0) continue;
      const endSlot = findSlotIdx(endT.h, endT.m);
      let stop = endSlot;
      if (stop < 0) {
        if (endT.h === 24 || (endT.h === 0 && endT.m === 0 && sIdx > 0)) stop = SLOT_COUNT;
      }
      if (stop < 0) continue;
      for (let i = sIdx; i < stop; i++) newTracks[trackIdx][i] = catId;
      const newNotes = { ...(base.notes || {}) };
      if (note) newNotes[`${trackIdx}:${sIdx}`] = note;
      next[dk] = { ...base, tracks: newTracks, notes: newNotes };
      touched.add(dk);
    } else if (section === 'cycle') {
      const dk = row[0] && String(row[0]).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dk)) continue;
      const get = (h) => { const i = headers.indexOf(h); return i >= 0 ? String(row[i] || '').trim() : ''; };
      const phaseRaw = get('阶段');
      const phase = PHASE_BY_LABEL[phaseRaw] || (phaseRaw === 'menses' || phaseRaw === 'ovulation' ? phaseRaw : null);
      if (!phase) continue;
      const base = next[dk] || emptyDay(dk);
      const cycle = { phase };
      const flow = FLOW_BY_LABEL[get('血量')];
      if (flow) cycle.flow = flow;
      const painRaw = get('疼痛');
      if (painRaw in PAIN_BY_LABEL) cycle.pain = PAIN_BY_LABEL[painRaw];
      const syms = get('症状').split(/[\/,，]/).map(s => s.trim()).filter(Boolean);
      if (syms.length) cycle.symptoms = syms;
      next[dk] = { ...base, cycle };
      touched.add(dk);
    }
  }
  return { next, touched };
}
